import { homeConstants } from '../constants';

export function homeReducers(state = {}, action) {
    switch (action.type) {
            
        // Get One-Click Action Details
        
        case homeConstants.getOneClickActionDetails_request:
            return {
                ...state,
                getOneClickActionDetails_requesting: true, getOneClickActionDetails_status: false,
            }
        case homeConstants.getOneClickActionDetails_success:
            return {
                ...state,
                getOneClickActionDetails_requesting: false, getOneClickActionDetails_status: true,
                oneClickActionDetails: action.details.data
            }
        case homeConstants.getOneClickActionDetails_failure:
            return {
                ...state,
                getOneClickActionDetails_requesting: false, getOneClickActionDetails_status: false, 
            }

        // Get Account Bill Details
        
        case homeConstants.getInvoiceDetailList_request:
            return {
                ...state,
                getInvoiceDetailList_requesting: true, getInvoiceDetailList_status: false,
            }
        case homeConstants.getInvoiceDetailList_success:
            return {
                ...state,
                getInvoiceDetailList_requesting: false, getInvoiceDetailList_status: true,
                invoiceDetailList: action.details.data,
                invoiceDetailListHeaders: action.details.headers,
            }
        case homeConstants.getInvoiceDetailList_failure:
            return {
                ...state,
                getInvoiceDetailList_requesting: false, getInvoiceDetailList_status: false, 
            }

        // Generate All Unbilled Invoices
        
        case homeConstants.generateAllUnbilledInvoices_request:
            return {
                ...state,
                generateAllUnbilledInvoices_requesting: true, generateAllUnbilledInvoices_status: false,
            }
        case homeConstants.generateAllUnbilledInvoices_success:
            return {
                ...state,
                generateAllUnbilledInvoices_requesting: false, generateAllUnbilledInvoices_status: true,
            }
        case homeConstants.generateAllUnbilledInvoices_failure:
            return {
                ...state,
                generateAllUnbilledInvoices_requesting: false, generateAllUnbilledInvoices_status: false, 
            }

        // Generate All Unbilled Advance Pay Invoices
        
        case homeConstants.generateAllUnbilledAdvancePayInvoices_request:
            return {
                ...state,
                generateAllUnbilledAdvancePayInvoices_requesting: true, generateAllUnbilledAdvancePayInvoices_status: false,
            }
        case homeConstants.generateAllUnbilledAdvancePayInvoices_success:
            return {
                ...state,
                generateAllUnbilledAdvancePayInvoices_requesting: false, generateAllUnbilledAdvancePayInvoices_status: true,
            }
        case homeConstants.generateAllUnbilledAdvancePayInvoices_failure:
            return {
                ...state,
                generateAllUnbilledAdvancePayInvoices_requesting: false, generateAllUnbilledAdvancePayInvoices_status: false, 
            }

        // Post All Unposted Invoices to Sql Account
        
        case homeConstants.postAllUnpostedInvoicesToSqlAccount_request:
            return {
                ...state,
                postAllUnpostedInvoicesToSqlAccount_requesting: true, postAllUnpostedInvoicesToSqlAccount_status: false,
            }
        case homeConstants.postAllUnpostedInvoicesToSqlAccount_success:
            return {
                ...state,
                postAllUnpostedInvoicesToSqlAccount_requesting: false, postAllUnpostedInvoicesToSqlAccount_status: true,
            }
        case homeConstants.postAllUnpostedInvoicesToSqlAccount_failure:
            return {
                ...state,
                postAllUnpostedInvoicesToSqlAccount_requesting: false, postAllUnpostedInvoicesToSqlAccount_status: false, 
            }

        // Post All Unposted Invoices to Sql Account
        
        case homeConstants.sendAllPendingInvoices_request:
            return {
                ...state,
                sendAllPendingInvoices_requesting: true, sendAllPendingInvoices_status: false,
            }
        case homeConstants.sendAllPendingInvoices_success:
            return {
                ...state,
                sendAllPendingInvoices_requesting: false, sendAllPendingInvoices_status: true,
            }
        case homeConstants.sendAllPendingInvoices_failure:
            return {
                ...state,
                sendAllPendingInvoices_requesting: false, sendAllPendingInvoices_status: false, 
            }

            // Get Account Bill Details
        
        case homeConstants.generateCompareUnpostedInvoices_request:
            return {
                ...state,
                generateCompareUnpostedInvoices_requesting: true, generateCompareUnpostedInvoices_status: false,
            }
        case homeConstants.generateCompareUnpostedInvoices_success:
            return {
                ...state,
                generateCompareUnpostedInvoices_requesting: false, generateCompareUnpostedInvoices_status: true,
                compareUnpostedInvoices: action.details.data,
            }
        case homeConstants.generateCompareUnpostedInvoices_failure:
            return {
                ...state,
                generateCompareUnpostedInvoices_requesting: false, generateCompareUnpostedInvoices_status: false, 
            }

        default:
            return state;
    }
}